import { QUESTIONS, SEPARATOR, createReader, formatDosage, unique } from './documentData'
import {
  DESTINATIONS_PT,
  GOODS_EN,
  GUIDE_QUESTIONS,
  formatCompletionDate,
  formatInterestedDetails,
  formatNumber,
  sortNumerically,
  translate
} from './guideData'
import { toDays } from './noticeData'

// Perguntas usadas só no Certificado de Fumigação
export const CERTIFICATE_QUESTIONS = {
  lpco: 173, // pai, dentro do bloco 171 (o PDF de IDs cita a 172, que é a de exportadores)
  // quantidade de produto da Fumigação (filha), em blocos repetidos: por shipper (119) e por porão (122)
  quantityByShipper: 119,
  quantityByHold: 122,
  // "Forma de aplicação" por tipo de serviço (só uma é respondida)
  methods: [177, 187, 543, 623, 307, 309, 312, 316, 626, 319],
  // porões marcados (Lineup, múltipla escolha "1" a "9"), igual à Notificação e à Carta
  selectedHolds: 196
}

// Opções das perguntas de método: [inglês, português]; o que não estiver aqui repete o texto da opção
export const METHODS = {
  TABLETS: ['TABLETS', 'PASTILHAS'],
  SACHET: ['SACHET', 'SACHÊ'],
  SLEEVES: ['SLEEVES', 'SLEEVES'],
  'FULL CARGO': ['FULL CARGO', 'CARGA TOTAL'],
  TOPO: ['TOP', 'TOPO'],
  'TOPO E FUNDO': ['TOP AND BOTTOM', 'TOPO E FUNDO'],
  'TOPO, MEIO E FUNDO': ['TOP, MIDDLE AND BOTTOM', 'TOPO, MEIO E FUNDO'],
  CONVENCIONAL: ['CONVENTIONAL', 'CONVENCIONAL'],
  'MIDDLE PIPE': ['MIDDLE PIPE', 'MIDDLE PIPE'],
  'TERMONEBULIZAÇÃO (TERMO FOGGER)': ['THERMAL FOGGING (THERMO FOGGER)', 'TERMONEBULIZAÇÃO (TERMO FOGGER)']
}

// "1.500,5" (com vírgula) é lido como número brasileiro; sem vírgula, como número comum
const parseNumber = text => Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text)

const sum = texts =>
  texts
    .map(parseNumber)
    .filter(Number.isFinite)
    .reduce((total, value) => total + value, 0)

export const buildCertificateData = ({ serviceOrder, childrenServiceOrders = [], assets = [] }) => {
  const { answers, answer, joined, treatmentPlace, treatmentAddress } = createReader({
    serviceOrder,
    childrenServiceOrders,
    assets
  })

  const port = answer(QUESTIONS.mapaPort).toUpperCase()
  const ship = answer(QUESTIONS.ship).toUpperCase()
  const goods = answer(QUESTIONS.goods).toUpperCase()
  const destination = answer(QUESTIONS.destination).toUpperCase()
  const dosage = unique(answers(...QUESTIONS.dosages).map(formatDosage)).join(SEPARATOR)
  // primeira pergunta de exposição respondida (horas)
  const hours = GUIDE_QUESTIONS.exposureTimes.map(answer).find(Boolean) || ''
  const days = toDays(Number(hours))
  const completionDate = formatCompletionDate(serviceOrder.endDate)
  const product = joined(QUESTIONS.product).toUpperCase()
  const method = (CERTIFICATE_QUESTIONS.methods.map(answer).find(Boolean) || '').toUpperCase()
  const [methodEn, methodPt] = METHODS[method] || [method, method]
  // as duas listas de quantidade somam o mesmo produto: vale a por shipper e, se vazia, a por porão
  const quantityTexts = answers(CERTIFICATE_QUESTIONS.quantityByShipper)
  const grams = sum(quantityTexts.length ? quantityTexts : answers(CERTIFICATE_QUESTIONS.quantityByHold))

  return {
    activityCode: serviceOrder.yearlyId || '',
    communicationNumber: answer(QUESTIONS.communicationNumber),
    lpco: joined(CERTIFICATE_QUESTIONS.lpco),
    port,
    goodsEn: translate(GOODS_EN, goods),
    goodsPt: goods,
    shipper: serviceOrder.place?.name || '',
    shipperDetails: formatInterestedDetails(serviceOrder.place?.fieldValues),
    otherShippers: joined(QUESTIONS.exporter),
    destinationEn: destination,
    destinationPt: translate(DESTINATIONS_PT, destination),
    ship,
    place: treatmentPlace,
    placeAddress: treatmentAddress,
    product,
    grams: grams > 0 ? formatNumber(grams) : '',
    dosageEn: dosage && `${dosage} GRAM(S) PER CBM`,
    dosagePt: dosage && `${dosage} GRAMA(S) POR M3`,
    hours,
    days,
    dateEn: completionDate.en,
    datePt: completionDate.pt,
    methodEn,
    methodPt,
    holds: sortNumerically(answer(CERTIFICATE_QUESTIONS.selectedHolds))
  }
}
